"use client"
import React, { useState } from "react";
import {
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Ratio,
  Row
} from "react-bootstrap";
import Asset from "@/components/shared/Asset";
import UralitySquareImage from "@/components/shared/UralitySquareImage";

import "@/components/shared/MediaItemGalleryView.css";
import { useMediaQuery } from "react-responsive";

export const MediaItemCard = ({
  galleryItem,
  className,
  cardClassName,
  onOwnerAction,
  ownerActions,
  onClick
}) => {
  return (
    <div
      className={`media-item-card ${className} ${onClick ? "clickable" : ""}`}
      onClick={onClick}
    >
      <div className={`default-card-wrapper ${cardClassName}`}>
        {ownerActions && (
          <div className="card-header">
            <DropdownButton
              className="ellipsis-dropdown"
              align="end"
              bsPrefix="none"
              title=""
            >
              {ownerActions.includes("EDIT") && (
                <Dropdown.Item
                  key="edit"
                  eventKey="edit"
                  onClick={() => onOwnerAction("EDIT", galleryItem)}
                >
                  <i className="material-icons">edit</i>Edit
                </Dropdown.Item>
              )}
              {ownerActions.includes("DELETE") && (
                <Dropdown.Item
                  key="delete"
                  eventKey="delete"
                  onClick={() => onOwnerAction("DELETE", galleryItem)}
                >
                  <i className="material-icons">delete</i>Delete
                </Dropdown.Item>
              )}
              {ownerActions.includes("APPROVE") && (
                <Dropdown.Item
                  key="approve"
                  eventKey="approve"
                  onClick={() => onOwnerAction("APPROVE", galleryItem)}
                >
                  <i className="material-icons">check</i>Approve
                </Dropdown.Item>
              )}
              {ownerActions.includes("REJECT") && (
                <Dropdown.Item
                  key="reject"
                  eventKey="reject"
                  onClick={() => onOwnerAction("REJECT", galleryItem)}
                >
                  <i className="material-icons">close</i>Reject
                </Dropdown.Item>
              )}
            </DropdownButton>
          </div>
        )}
        <Ratio aspectRatio="1x1">
          <>
            {galleryItem.assets && galleryItem.assets.length > 0 && (
              <>
                <UralitySquareImage
                  imageId={galleryItem.assets[0].id}
                  size="xxl"
                  imgClass="media-item-card-img"
                />
              </>
            )}
          </>
        </Ratio>
      </div>
    </div>
  );
};

export const MediaItemView = ({ galleryItem }) => {
  return (
    <div className="media-item-view">
      <Asset assets={galleryItem.assets} />
      {galleryItem.title && <h3>{galleryItem.title}</h3>}
      {galleryItem.text && <p>{galleryItem.text}</p>}
    </div>
  );
};

const MediaItemGalleryView = ({ mediaItemList }) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const [selectedGalleryItem, setSelectedGalleryItem] = useState(null);

  return (
    <>
      {isSm ? (
        <Container>
          {mediaItemList.map((galleryItem, index) => {
            return (
              <Row>
                <Col>
                  <MediaItemView galleryItem={galleryItem} />
                </Col>
              </Row>
            );
          })}
        </Container>
      ) : (
        <Container>
          <Row>
            <Col className={selectedGalleryItem ? "col-6" : "col-12"}>
              <Container>
                <Row>
                  {mediaItemList.map((galleryItem, index) => {
                    return (
                      <Col className={selectedGalleryItem ? "col-6" : "col-3"}>
                        <MediaItemCard
                          cardClassName={
                            selectedGalleryItem &&
                            selectedGalleryItem.id === galleryItem.id
                              ? "selected"
                              : ""
                          }
                          galleryItem={galleryItem}
                          onClick={() => setSelectedGalleryItem(galleryItem)}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Container>
            </Col>
            <Col className={selectedGalleryItem ? "col-6" : "hide"}>
              {selectedGalleryItem && (
                <MediaItemView galleryItem={selectedGalleryItem} />
              )}
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};
export default MediaItemGalleryView;
